import { Body, Controller, Delete, Get, Param, Patch, Post, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import { RequireModule } from '../../auth/decorators/require-module.decorator';
import { RequirePermission } from '../../auth/decorators/require-permission.decorator';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { GetUser } from '../../auth/get-user.decorator';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import {
  CreateNovedadDto,
  QueryNovedadesDto,
  UpdateNovedadDto,
} from '../dto/novedades.dto';
import { NovedadesService } from '../services/novedades.service';

@ApiTags('RRHH - Novedades de asistencia')
@Controller({ path: 'rrhh/novedades', version: '1' })
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('RRHH')
@ApiBearerAuth()
export class NovedadesController {
  constructor(private readonly service: NovedadesService) {}

  @Get()
  @RequirePermission('RRHH', 'RH_NOV_NOVEDAD_VER')
  @ApiOperation({ summary: 'Listar novedades (ausencias, tardanzas, salidas anticipadas)' })
  listar(@GetUser() user: LoginUserInfo, @Query() query: QueryNovedadesDto) {
    return this.service.listar(user.empresa_id, query);
  }

  @Post()
  @RequirePermission('RRHH', 'RH_NOV_NOVEDAD_CREAR')
  @ApiOperation({ summary: 'Registrar novedad' })
  crear(@GetUser() user: LoginUserInfo, @Body() dto: CreateNovedadDto) {
    return this.service.crear(user.empresa_id, dto, user.id);
  }

  @Patch(':id')
  @RequirePermission('RRHH', 'RH_NOV_NOVEDAD_EDITAR')
  @ApiOperation({ summary: 'Editar novedad (no permitido si ya está aplicada a liquidación)' })
  actualizar(
    @Param('id') id: string,
    @GetUser() user: LoginUserInfo,
    @Body() dto: UpdateNovedadDto,
  ) {
    return this.service.actualizar(id, user.empresa_id, dto);
  }

  @Delete(':id')
  @RequirePermission('RRHH', 'RH_NOV_NOVEDAD_ELIMINAR')
  @ApiOperation({ summary: 'Eliminar novedad' })
  eliminar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.eliminar(id, user.empresa_id);
  }
}
